import { REACT_APP_BE_API_URL } from '#shared';

import { fetchWithAuthRecovery } from '#shared/api';

import { validatePlaybackPackResponse } from './schemas';

import type { PlaybackPackWire } from './schemas';

export const playbackPackUrl = (fromIso: string, toIso: string): string =>
  `${REACT_APP_BE_API_URL ?? ''}api/map/playback?from=${encodeURIComponent(fromIso)}&to=${encodeURIComponent(toIso)}`;

interface FetchPlaybackPackArgs {
  fromIso: string;
  toIso: string;
  token: string;
  /** Decompressed bytes so far; a gzipped body's Content-Length counts compressed ones. */
  onBytes?: (received: number) => void;
  signal?: AbortSignal;
}

const readText = async (
  res: Response,
  onBytes: ((received: number) => void) | undefined,
): Promise<string> => {
  if (!res.body) {
    return res.text();
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let text = '';
  let received = 0;
  for (;;) {
    const { done, value } = await reader.read();
    if (done) {
      return text + decoder.decode();
    }
    received += value.byteLength;
    text += decoder.decode(value, { stream: true });
    onBytes?.(received);
  }
};

export const fetchPlaybackPack = async ({
  fromIso,
  toIso,
  token,
  onBytes,
  signal,
}: FetchPlaybackPackArgs): Promise<PlaybackPackWire> => {
  const res = await fetchWithAuthRecovery(
    playbackPackUrl(fromIso, toIso),
    token,
    { signal },
  );
  if (!res.ok) {
    throw new Error(`map playback pack failed (${res.status})`);
  }
  const validation = validatePlaybackPackResponse(
    JSON.parse(await readText(res, onBytes)) as unknown,
  );
  if (!validation.ok) {
    throw new Error(validation.message);
  }
  return validation.value;
};
